import { LitElement, html, css } from 'lit';


export class InfoPop extends LitElement {

  static get properties() {
    return {
      icon: { type: String },
      direction: { type: String },
    };
  }

  static get styles() {
    return [
      css`
:host {
  font-size: 14px;
  padding: 1em;
  position: absolute;
  background-color: var(--info-pop-bg);
  color: var(--info-pop-fg);
}

:host([placement="top-left"]) {

}
      `,
    ]
  }

  render() {
    return html`
      <div id="content">
        <slot name="content"></slot>
      </div>
    `;
  }

  constructor() {
    super();
    this.direction = 'top';
  }

  firstUpdate() {
    super.firstUpdated();
  }

}
